import * as R from 'ramda';
import { openSQLiteDatabase as openDatabaseFn } from './openDatabase.js';
import { fail } from 'assert';
import { getDatabaseName } from '../../../utils.js';
import async from 'async-es';
import * as Promise from 'bluebird';

export const sqlite_db = {};

export const openSQLiteDatabase = ({ alias, databaseName, databaseVersion, databaseDescription }) =>
  new Promise((success, fail) => {
    const sqliteDatabaseName = getDatabaseName(databaseName, databaseVersion);
    console.log(`Opening Database: ${sqliteDatabaseName}`);

    openDatabaseFn({
      name: sqliteDatabaseName,
      databaseVersion,
      databaseDescription,
    }).then(db => {
      sqlite_db[alias] = {
        info: {
          alias,
          name: sqliteDatabaseName,
          databaseVersion,
          databaseDescription,
        },
        db,
      };
      success();
    });
  }).catch(fail);

export const executeSql = databaseAlias => ({ sql, params = [], queue }) =>
  new Promise((success, reject) => {
    if (!sql && !queue) {
      reject('No sql or queue to execute');
    }
    const RsToArray = resultRows => {
      const result = [];
      for (let i = 0; i < resultRows.length; i++) {
        result.push(resultRows.item(i));
      }
      return result;
    };

    const dbManager = sqlite_db[databaseAlias].db;

    const executeTx = (txSql, txParams) =>
      new Promise((successExecuteTx, rejectExecuteTx) => {
        try {
          dbManager.transaction(tx => {
            tx.executeSql(
              txSql,
              txParams,
              (rsTX, result) => {
                console.log(result);
                successExecuteTx(RsToArray(result.rows));
              },
              (rsTX, error) => {
                rejectExecuteTx(error);
              }
            );
          });
        } catch (e) {
          console.log('DATABASE ERROR: ', e);
          rejectExecuteTx(e);
        }
      });

    const executeQueueTx = queue =>
      new Promise((successExecuteQueueTx, rejectExecuteQueueTx) => {
        const queueResults = [];
        let queueItemsProcessed = 0;
        dbManager.transaction(tx => {
          async.eachOfLimit(
            queue,
            500,
            ({ sql = '', params = [], callback = () => {} }, _, done) => {
              tx.executeSql(
                sql,
                params,
                (rsTX, result) => {
                  callback(RsToArray(result.rows));
                  queueResults.push(RsToArray(result.rows));
                  queueItemsProcessed++;
                  done();
                },
                (rsTX, error) => {
                  console.warn('Error Queue TX', error);
                  callback([]);
                  queueResults.push([]);
                  queueItemsProcessed++;
                  if (rsTX.txlock) {
                    console.log('TX LOCK QUEUE ABORTED');
                    const remainingQueueItems = R.slice(queueItemsProcessed, queue.length)(queue);
                    console.log('items remaining', remainingQueueItems);
                    if (remainingQueueItems.length > 0) {
                      console.log('CONTINUING THE QUEUE EXECUTION!!');
                      executeQueueTx(remainingQueueItems).then(result => {
                        successExecuteQueueTx(R.concat(queueResults, result));
                        done(error);
                      });
                    } else {
                      console.log('NO MORE ITEMS IN THE QUEUE TO PROCESS!!');
                      successExecuteQueueTx(queueResults);
                      done(error);
                    }
                  } else {
                    done();
                  }
                }
              );
            },
            () => {
              console.log('Queue Processed');
              successExecuteQueueTx(queueResults);
            }
          );
        });
      });

    if (sql) {
      executeTx(sql, params)
        .then(success)
        .catch(reject);
    } else {
      if (queue.length > 0) {
        executeQueueTx(queue)
          .then(success)
          .catch(reject);
      } else {
        success([]);
      }
    }
  });
